import { atom } from "jotai";

import { BookingWizard } from "../../types";

export const originalListOfBookingWizardStepsAtom = atom<
  BookingWizard.BookingWizardStepTitle[]
>([]);
